import { gql } from '@apollo/client';

export const getUserQuery = gql`
  query GetUser($input: GetUserInput!) {
    getUser(input: $input) {
      id
      username
      email
      avatar
      groupName
      joinDate
      status
      phoneNumber
      point
      __typename
    }
  }
`;
